/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Erika est inséminée pour la quatrième et dernière fois. Elle a maintenant terminé sa carrière et passe dans la catégorie “vache à saucisse”. Les vaches peuvent cependant facilement vivre durant 20 ans.`}</p>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  